/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  modalTextBox: {
    paddingRight: Tokens.spacing['$sp-2-5'],
  },
  modalFormContent: {
    display: 'flex',
    alignItems: 'center',
    marginTop: Tokens.spacing['$sp-2'],
    marginBottom: Tokens.spacing['$sp-3'],
  },
  copySecretKey: {
    marginRight: Tokens.spacing['$sp-5']
  },
  copyClientId: {
    marginRight: Tokens.spacing['$sp-5']
  },
  hide: {
    display: 'none !important'
  },
  divider: {
    borderBottom: `1px solid ${theme.palette.secondary.main}`,
    paddingBottom: Tokens.spacing['$sp-2'],
    width: '70%',
    display: 'inline-block',
    marginBottom: Tokens.spacing['$sp-14'],
  },
  iconBox: {
    float: 'right'
  },
  iconAlignment: {
    marginRight: Tokens.spacing['$sp-4']
  },
  styler: {
    marginBottom: Tokens.spacing['$sp-7-5']
  },
  formLabel: {
    marginBottom: Tokens.spacing['$sp-2'],
    fontWeight: '500',
    fontSize: Tokens.spacing['$sp-4'],
    color: theme.palette.text.primary,
  },
}));